import { resourceStoreTypes, resourceUndoUpserters, resourceUpserters } from '../core';

import { UnknownAction } from '@reduxjs/toolkit';
import type { QcsSyncResourceStore } from '../core/resourceStoreTypes';
import * as actions from './taxesActions';
import { type TaxProps } from './taxesTypes';

export const QcsSyncTagsStoreFactory = resourceStoreTypes.createTypedQcsSyncResourceStoreFactory<TaxProps>({
  resourceName: 'TAXES',
});

function reducer(
  state: QcsSyncResourceStore<TaxProps> = QcsSyncTagsStoreFactory(),
  action: UnknownAction,
): typeof state {
  switch (true) {
    case actions.getTaxCalculations.match(action):
      return state.set('isLoading', true);
    case actions.getTaxCalculationsSuccess.match(action):
      return resourceUpserters.upsertResources(state, action.payload);
    case actions.getTaxCalculationsFailure.match(action):
      return resourceUpserters.completeWithError(state, action.payload);

    case actions.createTax.match(action):
      return resourceUpserters.upsertResource(state, action.payload);
    case actions.createTaxSuccess.match(action):
      return resourceUpserters.upsertResource(state, action.payload);

    case actions.updateTax.match(action):
      return resourceUndoUpserters.upsertResourceSetupUndo(state, action, actions.updateTax);
    case actions.updateTaxSuccess.match(action):
      return resourceUpserters.upsertResource(state, action.payload);

    case actions.createTaxFailure.match(action):
    case actions.updateTaxFailure.match(action):
      return resourceUpserters.resetResources(state, action.payload);

    default:
      return state;
  }
}

export default reducer;
